import { combineReducers } from 'redux'
import MedcardOnlineVisitsAllReducer from './medcard.online_visits.all.reducer'
import MedcardOnlineVisitsByPatientReducer from './medcard.online_visits.bypatient.reducer'

const MedcardOnlineVisitsReducer = combineReducers({
  all: MedcardOnlineVisitsAllReducer,
  bypatient: MedcardOnlineVisitsByPatientReducer,
})

export default MedcardOnlineVisitsReducer